<template>
  <OurModal v-model="isShownModal" :title="$t('title.fleaMarket.filters')" mobile-footer-reverse>
    <FilterForm v-model="form" :regions="regions" :managers="managers" />

    <template #footer-left>
      <OurButton :text="$t('button.apply')" @click="onClickApplyButton" />

      <OurButton :text="$t('button.close')" variant="secondary" @click="onClickCloseButton" />
    </template>

    <template #footer-right>
      <OurButton
        class="button"
        :text="$t('button.clear')"
        variant="thirdary"
        @click="onClickCleanButton"
      />
    </template>
  </OurModal>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import FilterForm from "./components/FilterForm";
import filterMixin from "@/mixins/filter.mixin";
import { regionsAndManagersQuery } from "@/views/settings/dealership-applications/details/gql/queries";
import apolloMixin from "@/mixins/apollo.mixin";

const createDefaultForm = () => ({
  applicationId: "",
  companyCode: "",
  taxNumber: "",
  phone: "",
  email: "",
  fullName: "",
  statuses: [],
  regionIds: [],
  managerIds: [],
  date: {},
  withoutManager: false,
});

export default {
  name: "FilterModal",
  components: {
    FilterForm,
  },
  mixins: [filterMixin, apolloMixin],

  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: createDefaultForm(),
      regions: [],
      managers: [],
    };
  },

  computed: {
    ...mapState("dealershipApplications", ["filtersForm"]),

    isShownModal: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },

  watch: {
    isShownModal: "onChangeShownModal",
  },

  created() {
    this.setFiltersForm();
    this.getRegionsAndManagers();
  },

  beforeDestroy() {
    this.cleanForm();
    this.setFiltersForm();
  },

  methods: {
    ...mapMutations("dealershipApplications", ["SET_FILTERS_FORM"]),

    getMultiSelectQueryParams() {
      return ["statuses", "regionIds", "managerIds"];
    },

    cloneForm(form = createDefaultForm()) {
      const nextForm = {
        ...createDefaultForm(),
        ...form,
      };

      this.getMultiSelectQueryParams().forEach((key) => {
        nextForm[key] = Array.isArray(form?.[key]) ? [...form[key]] : [];
      });

      return nextForm;
    },

    onChangeShownModal() {
      if (this.isShownModal) {
        if (this.filtersForm) {
          this.getForm();
        }
      } else {
        this.cleanForm();
      }
    },

    getForm() {
      this.form = this.cloneForm(this.filtersForm);
    },

    cleanForm() {
      this.form = createDefaultForm();
      this.cleanQueryParam();
    },

    closeModal() {
      this.isShownModal = false;
      this.cleanForm();
    },

    onClickCloseButton() {
      this.closeModal();
    },

    onClickApplyButton() {
      this.setQueryParam();
      this.setFiltersForm();
      this.closeModal();
    },

    onClickCleanButton() {
      this.cleanForm();
    },

    setFiltersForm() {
      this.SET_FILTERS_FORM(this.cloneForm(this.form));
    },

    async getRegionsAndManagers() {
      const { regions, dealershipApplicationFilterManagers } = await this.$get(
        regionsAndManagersQuery
      );

      this.regions = regions || [];
      this.managers = dealershipApplicationFilterManagers || [];
    },
  },
};
</script>
